import React from 'react';

const Separator = ({ text, className = '', noMargin = false }) => {
    if (noMargin) {
        className += ' ml-0 mr-0'
    }

    if (!text) {
        return <hr className={`separator ${className}`} />
    }

    return (
        <div className={`d-flex justify-content-center separator ${className}`}>
            <div className="align-self-center">
                <hr/>
            </div>

            <div className="text-column align-self-center">
                { text }
            </div>

            <div className="align-self-center">
                <hr/>
            </div>
        </div>
    )
};

export default Separator;